import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=451c27da&"
import script from "./VideoComponent.vue?vue&type=script&lang=js&"
export * from "./VideoComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports